import * as css from './SubscriptionRow.css';
import {useTranslation} from 'react-i18next';
import ModeBtn from '../../../../component/modeBtn/ModeBtn';
import SubscriptionOptions from './SubscriptionOptions';
import {useRef} from 'react';
import {defaultImage} from '../../../../assets/symbols/images/defaultImage';
import {Button, Label} from '@tickchak/react-share/app';
import Association from '../../../../assets/icons/Association';
import IconGroups from '../../../../assets/icons/IconGroups';
import useShow from '../../../../hooks/useShow';
import AssigningEventsPop from '../../components/assigningEventsPop/AssigningEventsPop';
import {seriesTypeLabel} from '../../utils/subscriptionUtils';
import {calculatePriceRange, calculateSaleValidity, calculateSalesFraction, calculatePercentage} from '../../utils/planCalculations';
import PlanImage from '../../components/planImage/PlanImage';
import useMediumScreen from '../../../../hooks/useMediumScreen';
import {SubscriptionPlan} from '../../../../redux/subscription/subscription.type';
import {setCurrentPlan, updatePlan} from '../../../../redux/subscription/subscriptionActions';
import useGlobalShow from '../../../../hooks/useGlobalShow';

function SubscriptionRow({plan}: {plan: SubscriptionPlan}) {
    const {t} = useTranslation('subscriptions');
    const scrollContainerRef = useRef(null);
    const assigningEventsShow = useShow();
    const salesFraction = calculateSalesFraction(plan);
    const realizationPercentage = calculatePercentage(plan);
    const priceRange = calculatePriceRange(plan);
    const saleValidity = calculateSaleValidity(plan);
    const mediumDisplay = useMediumScreen();
    const createSubscriptionShow = useGlobalShow('isOpenCreateSubscription');
    const handleEditPlan = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCurrentPlan(plan.planTid);
        createSubscriptionShow.open();
    };

    return (
        <css.row data-cy="subscriptionRow" ref={scrollContainerRef}>
            <PlanImage
                image={plan.image?.path || defaultImage}
                realizationPercentage={realizationPercentage}
                onEditClick={handleEditPlan}
                variant="row"
            />
            <css.seriesInfo>
                <Label backgroundColor={seriesTypeLabel[plan.planType]?.color}>
                    {t(seriesTypeLabel[plan.planType]?.label)}
                </Label>
                <css.seriesTitle>{plan.title}</css.seriesTitle>
            </css.seriesInfo>
            <css.detail className='saleValidity'>
                <css.value>{saleValidity}</css.value>
                <css.label>{t('saleValidity')}</css.label>
            </css.detail>
            <css.detail className='priceRange'>
                <css.value>{priceRange}</css.value>
                <css.label>{t('priceRange')}</css.label>
            </css.detail>
            <css.detail className='sales'>
                <css.value>{salesFraction}</css.value>
                <css.label>{t('sales')}</css.label>
            </css.detail>
            <css.associateEvents>
                <Button
                    variant="brand"
                    size="category"
                    iconStart={<Association />}
                    onClick={() => {
                        assigningEventsShow.open();
                    }}
                >
                    {mediumDisplay ? (
                        plan.eventsCount > 0 ? <css.counts margin={'0px'}>{plan.eventsCount}</css.counts> : ''
                    ) : (
                        <>
                            {t('associateEvents')}
                            {plan.eventsCount > 0 && <css.counts>{plan.eventsCount}</css.counts>}
                        </>
                    )}
                </Button>
                <Button
                    variant="brand"
                    size="category"
                    iconStart={<IconGroups />}
                    disabled={true}
                    onClick={() => {
                        // TODO: Implement update plan active status
                        console.log('Associate groups', plan.planTid);
                    }}
                >
                    {plan.groupsCount > 0 ? <css.counts>{plan.groupsCount}</css.counts> : ''}
                </Button>
                <ModeBtn
                    status={plan.active}
                    className={'small'}
                    click={() => {updatePlan(plan.planTid, {active: !plan.active}).then();} }
                    dataCyName={`subscription-${plan.planTid}`} requestStatus={undefined} dataTitle={undefined} text={undefined}                    />
                <SubscriptionOptions plan={plan} />
            </css.associateEvents>
            {assigningEventsShow.isOpen && (
                <AssigningEventsPop
                    show={assigningEventsShow}
                    onClose={assigningEventsShow.close}
                    planTid={plan.planTid}
                    subscriptionTitle={plan.title}
                    subscriptionSubtitle={t(seriesTypeLabel[plan.planType].label)}
                />
            )}
        </css.row>
    );
}

export default SubscriptionRow;

